export default {
  title: {
    en: 'Hot combo tips',
  },
  totalOdds: {
    en: 'Total odds',
  },
  addToBetslip: {
    en: 'Add to betslip',
  },
}
